// Third Party Imports
import React from 'react';
import {isEmpty, get} from 'lodash';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import './ConfirmBrand.less';
import { getBrandImageUrl, getFlagImageUrl } from '../../utils/constants';

import backgroundImage from '../../images/cabin-blue-create-account-page.svg';
import ConfirmBrandButtonHolder from '../ButtonHolder/ConfirmBrandButtonHolder';
import AlertBox from "../Alert/Alert";
import { ButtonPrimary } from '@homeaway/react-buttons';

// HA Artifactory Imports
import FormSelect from '@homeaway/react-form-select';

// Relative Imports
import currencyActions from '../../actions/currency';
import appActions from '../../actions/actions';
import getCurrencySymbol from '../utils/currencyUtil';

function mapStateToProps(state) {
    return {
        currency: state.currency.currency || '',
        dyff: get(state, 'app.dyff', ''),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        appActions: bindActionCreators(appActions, dispatch),
        currencyActions: bindActionCreators(currencyActions, dispatch),
        dispatch
    };
}

@connect(mapStateToProps, mapDispatchToProps)
export default class ConfirmBrand extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.triggerEdapPageViewAction();
    }

    getListItems = (currencyList) => {
        const {translations} = this.props;
        const items = currencyList && currencyList.length > 0 ?
            currencyList.map((e) => ({
                label: `${getCurrencySymbol(e)} (${translations[`ipmob.currency.${e}`] ? translations[`ipmob.currency.${e}`] : e})`,
                value: e
            })) :
            [];
        items.unshift('');
        return items;
    }
    
    handleCurrencyChange = (e) => {
        const value = e.target.value;
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: 'Currency selected',
            eventaction: 'Currency selected',
            highfrequency: 'true'
        }, {});
        this.props.currencyActions.setCurrency(value);
        if (value.trim() === '') {
            this.props.currencyActions.setCurrencyChangeError('ipmob.input.field.required');
            this.props.currencyActions.enableContinueButton(false);
        } else {
            this.props.currencyActions.setCurrencyChangeError(null);
            this.props.currencyActions.enableContinueButton(true);
        }
    }

    renderCurrencyComponent = (currencyList) => {
        const {currency, translations, currencyChangeError} = this.props;

        return  (
            <FormSelect
                id="currency"
                className="currency-select"
                name={translations['ipmob.currency']}
                items={this.getListItems(currencyList)}
                value={currency}
                onChange={this.handleCurrencyChange}
                label={translations['ipmob.currency']}
                errorMsg={translations[currencyChangeError]}
            />
        );
    }

    getConfirmBrandContent(isPPM, translations, primarySite, getYesButtonClick, getNoButtonClick, brandImage, flagImage, isSingleBrandPPMtoIPM, currencySelectionRequired) {
        const HANDLE_LANGUAGE_CURRENCY_MISMATCH = this.props.dyff?.SHARED_HANDLE_SSO_LANGUAGE_CURRENCY_MISMATCH

        return (
            <div className="page-content">
                <div>
                    <h1 className="header">{isPPM && !HANDLE_LANGUAGE_CURRENCY_MISMATCH ? translations['ipmob.multiple_accounts.heading'] : translations['ipmob.confirm_brand.heading']}</h1>
                </div>
                <div className="confirm-brand-pg-description-1">
                    {/* eslint-disable-next-line react/no-danger */}
                    <p dangerouslySetInnerHTML={{ __html: isPPM && !HANDLE_LANGUAGE_CURRENCY_MISMATCH ? translations['ipmob.confirm_brand.description_1'] : translations['ipmob.confirm_brand.description_3']}} />
                </div>
                {isPPM && !HANDLE_LANGUAGE_CURRENCY_MISMATCH && <div className="confirm-brand-pg-description-2">
                    {/* eslint-disable-next-line react/no-danger */}
                    <p dangerouslySetInnerHTML={{ __html: translations['ipmob.confirm_brand.description_2']}} />
                </div>}
                <div className="confirm-brand-pg-content">
                    <ConfirmBrandButtonHolder
                        enableContinueButton={false}
                        handleContinueButtonClick={null}
                        translations={translations}
                        continueButtonId='confirmBrandButton'
                        data={primarySite}
                        brandImage={brandImage}
                        flagImage={flagImage}
                        isSingleBrandPPMtoIPM={isSingleBrandPPMtoIPM}
                        languageCurrencyMismatch={HANDLE_LANGUAGE_CURRENCY_MISMATCH} // this will go away once the dyff is removed
                    />

                    {currencySelectionRequired && (
                        <div className="single-brand-multi-currency-select">
                            {this.renderCurrencyComponent(primarySite.currencies)}
                        </div>
                    )}

                    <div className="confirm-brand-pg-buttons">
                        <ButtonPrimary
                            className="confirm-brand-pg-change"
                            label={translations['ipmob.confirm_brand.button_text_1']}
                            type="submit"
                            value="Submit"
                            id={'NoThisIsNotCorrectButton'}
                            onClick={event => getNoButtonClick(event)}
                        />
                        <ButtonPrimary
                            label={translations['ipmob.confirm_brand.button_text_2']}
                            type="submit"
                            value="Submit"
                            id={'YesThisIsCorrectButton'}
                            disabled={currencySelectionRequired && !this.props.currency}
                            onClick={event => getYesButtonClick(event, primarySite)}
                        />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const {
            translations,
            primarySite,
            integratedBrandsPrimarySiteList,
            serviceError,
            isPPM,
            handleYesButtonClick,
            handleNoButtonClick,
            handleAlertDismiss
        } = this.props;

        let site = primarySite;

        // if primarySite is not set prior to loading ConfirmBrand,
        // this is a new PPM --> IPM user with only one account.
        const isSingleBrandPPMtoIPM = isEmpty(site) && integratedBrandsPrimarySiteList && integratedBrandsPrimarySiteList.length === 1;
        if (isSingleBrandPPMtoIPM) {
            site = integratedBrandsPrimarySiteList[0];
        }
        const currencySelectionRequired = isSingleBrandPPMtoIPM && site?.currencies?.length > 1;

        const brandImage = getBrandImageUrl(site.name);
        const flagImage = getFlagImageUrl(site.name);

        return (
            <div className="confirm-brand-pg">
                <div className="confirm-brand-pg-wrapper container">
                    {
                        (serviceError)
                            ? <div className="alert-panel">
                                <AlertBox
                                    messageKey={serviceError}
                                    translations={translations}
                                    handleAlertDismiss={handleAlertDismiss}
                                    size={'sm'}
                                />
                            </div>
                            : null
                    }
                    <img className="confirm-brand-pg-bg-img" src={backgroundImage()} />
                    {this.getConfirmBrandContent(isPPM, translations, site, handleYesButtonClick, handleNoButtonClick, brandImage, flagImage, isSingleBrandPPMtoIPM, currencySelectionRequired)}
                </div>
            </div>
        );
    }

}
